import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';
import PlaceIcon from '@mui/icons-material/Place';
import { Translate } from '../../../../../../../shared/LanguageService';
import { ExpandingButton } from '../../../shared/selection/view/ExpandingButton';

type PlacePinButtonProps = {
    isPinning: boolean;
    onPinToggle: () => void;
    onPinCancel: () => void;
};

export function PlacePinButton({ isPinning, onPinToggle, onPinCancel }: PlacePinButtonProps) {
    return (
        <Box
            component="nav"
            role="toolbar"
            aria-label="Place pin image actions"
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            }}
        >
            <Tooltip
                placement="top"
                title={isPinning ? '' : Translate('image-processing/button-label/place-pin')}
            >
                <span>
                    <Button
                        variant="outlined"
                        onClick={onPinToggle}
                        disabled={isPinning}
                        aria-label={Translate('image-processing/button-label/place-pin')}
                        sx={{
                            minWidth: 0,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '2px',
                            px: 1.5
                        }}
                    >
                        <PlaceIcon fontSize="small" />
                    </Button>
                </span>
            </Tooltip>

            <ExpandingButton
                variant="outlined"
                startIcon={<CloseIcon />}
                data-visible={isPinning}
                aria-hidden={!isPinning}
                tabIndex={isPinning ? 0 : -1}
                onClick={onPinCancel}
                sx={{ transitionDelay: isPinning ? '50ms' : '0ms' }}
            >
                {Translate('image-processing/button-label/select-many/disable')}
            </ExpandingButton>
        </Box>
    );
}
